export default {
  OneQuarter: 'oneQuarterFraction',
  OneThird: 'oneThirdFraction',
  OneHalf: 'oneHalfFraction',
  TwoThirds: 'twoThirdsFraction',
  ThreeQuarters: 'threeQuartersFraction',
  Full: 'full',
}
